// extracted by mini-css-extract-plugin
module.exports = {"TherapyArticles":"TherapyArticles_TherapyArticles__3omUi"};